import { ProfileFormData } from "./ProfileFormData";

export class EmploymentPositionData
{
    businessName?: string;
    positionHeld?: string;
    employmentStart?: Date;
}

export class EmploymentInfoFormData extends ProfileFormData
{
    constructor(_applicantId: number, _pageId: string)
    {
        super(_applicantId, _pageId);
    }

    employedStatusId?: number;
    numCurrentJobs?: number;
    typeOfSelfEmploymentWork?: string;
    selfEmploymentStart?: Date;
    positionData?: EmploymentPositionData[];
    relevantExperience?: boolean;
    employedRecently?: boolean;
    certify?: boolean;
    priorLearningAssessment?: boolean;

    toJSON()
    {
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,

            employedStatusId: this.employedStatusId,
            numCurrentJobs: this.numCurrentJobs,
            typeOfSelfEmploymentWork: this.typeOfSelfEmploymentWork,
            selfEmploymentStart: this.selfEmploymentStart,
            positionData: this.positionData,
            relevantExperience: this.relevantExperience,
            employedRecently: this.employedRecently,
            certify: this.certify,
            priorLearningAssessment: this.priorLearningAssessment,
        };
    }
}

export interface SanitizedFormData
{
    employedStatusId: number;
    numCurrentJobs: number;
    typeOfSelfEmploymentWork: string;
    selfEmploymentStart?: Date;
    positionData: EmploymentPositionData[];
    relevantExperience?: boolean;
    employedRecently?: boolean;
    certify?: boolean;
    priorLearningAssessment?: boolean;
}
